import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import type { Verse } from '../../types';

export default function Home() {
  const [verse, setVerse] = useState<Verse | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVerseOfWeek = async () => {
      const { data } = await supabase
        .from('verses')
        .select('*')
        .limit(1)
        .single();
      
      setVerse(data);
      setLoading(false);
    };

    fetchVerseOfWeek();
  }, []);

  const quickLinks = [
    { path: '/bible', icon: '📖', label: 'Biblia', color: 'bg-primary' },
    { path: '/events', icon: '📅', label: 'Eventos', color: 'bg-secondary' },
    { path: '/studies', icon: '📝', label: 'Estudios', color: 'bg-accent' },
    { path: '/preachings', icon: '🎤', label: 'Predicas', color: 'bg-green-600' },
    { path: '/songs', icon: '🎵', label: 'Canciones', color: 'bg-purple-600' },
    { path: '/tickets', icon: '🎟️', label: 'Boletos', color: 'bg-orange-500' },
    { path: '/dictionary', icon: '📖', label: 'Diccionario', color: 'bg-teal-600' },
    { path: '/prayers', icon: '🙏', label: 'Oración', color: 'bg-pink-600' },
  ];

  return (
    <div className="space-y-6">
      <section className="bg-gradient-to-r from-primary to-secondary rounded-lg p-6 text-white">
        <h2 className="text-2xl font-bold mb-2">Bienvenido a Brisas</h2>
        <p className="opacity-90">Tu aplicación de comunicación ministerial</p>
      </section>

      {!loading && verse && (
        <Link to="/verse" className="card block bg-amber-50 border-l-4 border-amber-500">
          <div className="flex items-start gap-3">
            <span className="text-2xl">📖</span>
            <div>
              <h3 className="font-semibold text-amber-800">Versículo de la Semana</h3>
              <p className="text-sm text-amber-700 mt-1 line-clamp-2">{verse.text}</p>
              <p className="text-xs text-amber-600 mt-1">
                {verse.chapter}:{verse.verse}
              </p>
            </div>
          </div>
        </Link>
      )}

      <section>
        <h3 className="font-semibold text-[#E5E5EA] mb-3">Accesos Rápidos</h3>
        <div className="grid grid-cols-4 gap-3">
          {quickLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className="flex flex-col items-center p-3 rounded-md bg-white shadow-sm"
            >
              <span className="text-2xl mb-1">{link.icon}</span>
              <span className="text-xs text-[#B3B3B3] text-center">{link.label}</span>
            </Link>
          ))}
        </div>
      </section>

      <section>
        <h3 className="font-semibold text-[#E5E5EA] mb-3">Próximos Eventos</h3>
        <div className="card">
          <p className="text-[#8E8E93] text-sm text-center py-4">
            No hay eventos próximos
          </p>
        </div>
      </section>
    </div>
  );
}
